import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import * as React from 'react';
import ButtonContent from './ButtonContent';
import ButtonBase from './ButtonBase';
var ButtonBaseWithContent = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var as = _ref.as,
      forwardedAs = _ref.forwardedAs,
      _ref$noIconWrapper = _ref.noIconWrapper,
      noIconWrapper = _ref$noIconWrapper === void 0 ? false : _ref$noIconWrapper,
      _ref$noChildren = _ref.noChildren,
      noChildren = _ref$noChildren === void 0 ? false : _ref$noChildren,
      icon = _ref.icon,
      iconRight = _ref.iconRight,
      iconMargin = _ref.iconMargin,
      iconRightMargin = _ref.iconRightMargin,
      iconSize = _ref.iconSize,
      iconRightSize = _ref.iconRightSize,
      iconTopPosition = _ref.iconTopPosition,
      iconRightTopPosition = _ref.iconRightTopPosition,
      title = _ref.title,
      subTitle = _ref.subTitle,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$vertical = _ref.vertical,
      vertical = _ref$vertical === void 0 ? false : _ref$vertical,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["as", "forwardedAs", "noIconWrapper", "noChildren", "icon", "iconRight", "iconMargin", "iconRightMargin", "iconSize", "iconRightSize", "iconTopPosition", "iconRightTopPosition", "title", "subTitle", "size", "vertical", "children"]);

  return /*#__PURE__*/React.createElement(ButtonBase, _extends({
    vertical: vertical,
    ref: forwardedRef,
    forwardedAs: as != null ? as : forwardedAs
  }, props), /*#__PURE__*/React.createElement(ButtonContent, {
    noIconWrapper: noIconWrapper,
    noChildren: noChildren,
    icon: icon,
    iconRight: iconRight,
    iconMargin: iconMargin,
    iconRightMargin: iconRightMargin,
    iconSize: iconSize,
    iconRightSize: iconRightSize,
    iconTopPosition: iconTopPosition,
    iconRightTopPosition: iconRightTopPosition,
    title: title,
    subTitle: subTitle,
    size: size,
    vertical: vertical,
    content: children
  }));
});
export default ButtonBaseWithContent;